module.exports = __webpack_public_path__ + "img/c06_unitstartechbowmanchampion_Normal_ua.d0cac067.webp";